import { createReducer, on } from '@ngrx/store';
import { RoutingState } from 'src/app/models/state/routing-state.model';
import { RoutingActions } from '../actions/routing.actions';
import { get, save } from 'src/app/data/utils/localstorage.util';

const ROUTING_KEY = 'RoutingState';

const initialState = {
	initialRoute: '/',
	currentRoute: '/',
};

const getInitialState = (initialState): RoutingState => {
	const stateFromLocalStorage = get<RoutingState>(ROUTING_KEY);
	if (stateFromLocalStorage !== null) {
		return stateFromLocalStorage;
	}

	return initialState;
};

export const routingReducer = createReducer(
	getInitialState(initialState),
	on(
		RoutingActions.addCurrentRoute,
		(state, { currentRoute }): RoutingState => {
			const newState: RoutingState = { ...state, currentRoute };
			saveSateToLocalStorage(newState);
			return newState;
		}
	),
	on(RoutingActions.resetCurrentRoute, (state): RoutingState => {
		const newState: RoutingState = { ...state, currentRoute: '/' };
		saveSateToLocalStorage(newState);
		return newState;
	})
);

function saveSateToLocalStorage(newState: RoutingState) {
	save(ROUTING_KEY, newState);
}
